import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";

let UnsavedChangesDialogComponent = {
    selector: "vcUnsavedChangesDialog",
    templateUrl:
        "/angular/components/dashboard/unsaved-changes-dialog.component.html",
    bindings: {},
    controller: class UnsavedChangesDialogController {
        private dialog: DialogUtils;

        constructor(DialogUtils: DialogUtils) {
            this.dialog = DialogUtils;
        }

        confirm(): void {
            this.dialog.hide();
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("dashboard")
    .component(
        UnsavedChangesDialogComponent.selector,
        UnsavedChangesDialogComponent
    );
